var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prndl"},_vm._l((_vm.options),function(option){return _c('span',{key:option,class:{selected: option === _vm.current}},[_vm._v(" "+_vm._s(option)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }